import { React } from '../../Imports';
import { Outlet } from 'react-router-dom';
import { ApiContext, IApplicationOptions } from '$Utilities/api';

interface LayoutProps {
    apiOptions: IApplicationOptions;
}

const Layout = (props: LayoutProps) => {
    return (
        <ApiContext.Provider value={props.apiOptions}>
            <Outlet />
        </ApiContext.Provider>
    );
};

export { Layout };